/**
 * S3 stores a smaller variant alongside the original with `-thumbnail` before the
 * file extension (same convention as my-files and brand visual direction).
 */
export function deriveAttachmentThumbnailUrl(
  url: null | string | undefined,
): null | string {
  if (!url) return null;

  const thumbnailUrl = url.replace(/(\.[\w-]+)$/i, "-thumbnail$1");

  return thumbnailUrl === url ? null : thumbnailUrl;
}

export function hasLocalFileContent(file: File): boolean {
  return file.size > 0;
}
